import React, { useContext, useState } from 'react';
import AppContext from '../../context/app/appContext';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';

const Selects = ({ taxonomy }) => {
  const {
    postType,
    getFiltredPosts,
    translations,
    baseUrl,
    params,
  } = useContext(AppContext);
  const { settings, terms } = taxonomy;

  if (!terms) {
    return null;
  }

  let options = terms.map((term) => {
    return {
      label: term.name,
      value: term.slug,
    };
  });

  let [selected, setSelected] = useState(
    options.filter((option) =>
      (params[settings.name] || []).includes(option.value)
    )
  );

  const onChange = (e, select) => {
    setSelected(e);
    let { name } = select;

    let value = Array.from(e || [], (option) => option.value);
    getFiltredPosts(name, value);

    handlePushState();
  };

  const handlePushState = () => {
    const formData = params || {};
    let formDataForUrl = {};
    let url = '';

    for (const key in formData) {
      const value = formData[key];

      if ([] === value) {
        continue;
      }

      const taxKey = key.replace('-', '_');
      formDataForUrl[taxKey] = value;
    }

    formDataForUrl = Object.entries(formDataForUrl).filter(
      ([key, value]) => value.length > 0
    );

    if (formDataForUrl.length !== 0) {
      const data = new URLSearchParams(formDataForUrl);
      url = `?${decodeURIComponent(data.toString())}`;
    } else {
      url = '';
    }
    window.history.pushState(params, document.title, `${baseUrl}${url}`);
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <i className="icon-arrow-down" />
      </components.DropdownIndicator>
    );
  };

  const Option = (props) => {
    return (
      <components.Option {...props}>
        <input type="checkbox" value="1" />
        <label className="filter-label">{props.label}</label>
      </components.Option>
    );
  };

  const MultiValueRemove = () => null;

  const MultiValueContainer = ({ selectProps, data }) => {
    const label = data.label;
    const allSelected = selectProps.value;
    const index = allSelected.findIndex(selected => selected.label === label);
    const isLastSelected = index === allSelected.length - 1;
    const labelSuffix = isLastSelected ? '' : ', ';
    let val = `${label}${labelSuffix}`;

    if(allSelected.length !== 1) {
      val = `${allSelected.length} ${translations.selected} ${settings.label.toLowerCase()}`
    }

    return (
      <span style={{ height: 60, position: 'absolute', top: 21 }}>
        {val}
      </span>
    );
  };

  return (
    <div
      className={`mb-2 my-sm-2 my-md-0 ${
        postType === 'asset'
          ? 'col-12 col-sm-6 col-md-4'
          : 'col-12 col-sm-6 col-md-3'
      }`}
    >
      <div className="component-archive-filter-select">
        <Select
          components={{
            Option,
            DropdownIndicator,
            MultiValueContainer: MultiValueContainer,
          }}
          isSearchable={false}
          hideSelectedOptions={false}
          closeMenuOnSelect={false}
          isMulti
          openOnFocus={true}
          autofocus={true}
          className="select-filter"
          classNamePrefix="select-filter"
          options={options}
          name={`${escape(settings.name)}`}
          placeholder={settings.placeholder}
          onChange={onChange}
          value={selected}
          noOptionsMessage={() => 'Inga val'}
          MultiValueRemove={MultiValueRemove}
          styles={{
            valueContainer: (provided) => {
              return {
                ...provided,
                maxHeight: 60,
              };
            },
          }}
        />
      </div>
    </div>
  );
};

Selects.propTypes = {
  taxonomy: PropTypes.object.isRequired,
};

export default Selects;



// WEBPACK FOOTER //
// ./src/components/Selects/Selects.js